import { requireDateOnlyString, type DateOnlyString } from "../utils/dateOnly";

export interface DateOnlyQueryRange {
  from?: DateOnlyString;
  to?: DateOnlyString;
}

interface DateOnlyQueryRangeInput {
  from?: unknown;
  to?: unknown;
}

interface DateOnlyQueryRangeFieldNames {
  from: string;
  to: string;
}

export function normalizeDateOnlyQueryRange(
  input: DateOnlyQueryRangeInput,
  fieldNames: DateOnlyQueryRangeFieldNames
): DateOnlyQueryRange {
  const from = normalizeOptionalDateOnly(input.from, fieldNames.from);
  const to = normalizeOptionalDateOnly(input.to, fieldNames.to);

  if (from && to && from > to) {
    throw new Error(`${fieldNames.from} must not be after ${fieldNames.to}`);
  }

  return { from, to };
}

function normalizeOptionalDateOnly(
  value: unknown,
  fieldName: string
): DateOnlyString | undefined {
  if (value === undefined) return undefined;
  return requireDateOnlyString(value, fieldName);
}
